import React, { useState, useEffect } from 'react';

const TimerWithHours = ({ text, countdown, onTimerUpdate, sec }) => {
    const [timeLeft, setTimeLeft] = useState(countdown);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prevTime => {
                const newTime = prevTime - 1;
                onTimerUpdate(newTime);
                return newTime;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [onTimerUpdate]);

    const formatTime = time => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;
        return `${hours > 0 ? hours + ' hr ' : ''}${minutes < 10 ? '0' + minutes : minutes} min ${seconds < 10 ? '0' + seconds : seconds} sec`;
    };


    return (
       
            <p className='mb-0 text-danger'>{text} {formatTime(timeLeft)}</p>
      
    );
};

export default TimerWithHours;